"use strict";
var OverflowButtonType;
(function (OverflowButtonType) {
    /** No overflow */
    OverflowButtonType[OverflowButtonType["none"] = 0] = "none";
    /** +1 overflow icon */
    OverflowButtonType[OverflowButtonType["descriptive"] = 1] = "descriptive";
    /** More overflow icon */
    OverflowButtonType[OverflowButtonType["more"] = 2] = "more";
    /** Chevron overflow icon */
    OverflowButtonType[OverflowButtonType["downArrow"] = 3] = "downArrow";
})(OverflowButtonType = exports.OverflowButtonType || (exports.OverflowButtonType = {}));

//# sourceMappingURL=Facepile.Props.js.map



//////////////////
// WEBPACK FOOTER
// ../components/Facepile/Facepile.Props.js
// module id = 201
// module chunks = 0